import React from "react";
import { Card, CardProps } from "@/components/Card";
import { ChevronRight } from "@mui/icons-material";
import { cn } from "@/helpers/utils";

interface ClickableCardProps extends CardProps {
  title?: string;
}

const ClickableCard = (props: ClickableCardProps) => {
  const { title, ...cardProps } = props;
  return (
    <div>
      <label className="subtitle mb-4 text-base font-semibold">{title}</label>
      <Card
        bordered={true}
        hoverable={true}
        {...cardProps}
        className={cn("cursor-pointer", props.className)}
      >
        <div>
          <div className="pr-5">{props.children}</div>
          <div className="absolute right-0 top-0 h-full">
            <div className="flex h-full items-center">
              <ChevronRight
                className="flex h-full items-center"
                style={{ fontSize: 34 }}
              />
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export { ClickableCard };
